'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _DialogOverlay, _DialogPrimitive$Clos;
var _excluded = ["className"],
  _excluded2 = ["className", "hideClose", "children", "size"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className"];
import * as React from 'react';
import CloseSmall from '@crehana/compass.icons.outline/CloseSmall';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { cn } from "../utils";

/**
 * @deprecated The preferred way to use dialogs is through the GlobalModals component from '@crehana/compass.ui/modals/globals'.
 * If you need more control, you can use the individual dialog components from '@crehana/compass.ui/modals/dialogs/basic-dialog' or '@crehana/compass.ui/modals/dialogs/complex-dialog'.
 * This component will be removed in a future version.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Dialog = DialogPrimitive.Root;

/**
 * @deprecated The preferred way to use dialogs is through the GlobalModals component from '@crehana/compass.ui/modals/globals'.
 * If you need more control, you can use the individual dialog components from '@crehana/compass.ui/modals/dialogs/basic-dialog' or '@crehana/compass.ui/modals/dialogs/complex-dialog'.
 * This component will be removed in a future version.
 */
var DialogTrigger = DialogPrimitive.Trigger;

/**
 * @deprecated The preferred way to use dialogs is through the GlobalModals component from '@crehana/compass.ui/modals/globals'.
 * If you need more control, you can use the individual dialog components from '@crehana/compass.ui/modals/dialogs/basic-dialog' or '@crehana/compass.ui/modals/dialogs/complex-dialog'.
 * This component will be removed in a future version.
 */
var DialogPortal = DialogPrimitive.Portal;

/**
 * @deprecated The preferred way to use dialogs is through the GlobalModals component from '@crehana/compass.ui/modals/globals'.
 * If you need more control, you can use the individual dialog components from '@crehana/compass.ui/modals/dialogs/basic-dialog' or '@crehana/compass.ui/modals/dialogs/complex-dialog'.
 * This component will be removed in a future version.
 */
var DialogClose = DialogPrimitive.Close;

/**
 * @deprecated The preferred way to use dialogs is through the GlobalModals component from '@crehana/compass.ui/modals/globals'.
 * If you need more control, you can use the individual dialog components from '@crehana/compass.ui/modals/dialogs/basic-dialog' or '@crehana/compass.ui/modals/dialogs/complex-dialog'.
 * This component will be removed in a future version.
 */
var DialogOverlay = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(DialogPrimitive.Overlay, _objectSpread({
    ref: ref,
    className: cn('tw-fixed tw-inset-0 tw-z-dialog tw-bg-neutral-light-800 tw-opacity-50 tw-backdrop-blur-sm data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0', className)
  }, props));
});
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;

/**
 * @deprecated The preferred way to use dialogs is through the GlobalModals component from '@crehana/compass.ui/modals/globals'.
 * If you need more control, you can use the individual dialog components from '@crehana/compass.ui/modals/dialogs/basic-dialog' or '@crehana/compass.ui/modals/dialogs/complex-dialog'.
 * This component will be removed in a future version.
 */
var DialogContent = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    hideClose = _ref2.hideClose,
    children = _ref2.children,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'sm' : _ref2$size,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(DialogPortal, {
    children: [_DialogOverlay || (_DialogOverlay = /*#__PURE__*/_jsx(DialogOverlay, {})), /*#__PURE__*/_jsxs(DialogPrimitive.Content, _objectSpread(_objectSpread({
      ref: ref,
      className: cn('tw-fixed tw-left-[50%] tw-top-[50%] tw-rounded tw-max-w-[327px] tw-z-dialog tw-w-full tw-translate-x-[-50%] tw-translate-y-[-50%] tw-bg-neutral-light-100 tw-duration-200', 'data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95', 'dark:tw-bg-elevation-dark-00 dark:tw-text-neutral-light-100', 'tw-max-h-[calc(100vh-2.4rem)] tw-overflow-auto', size === 'sm' && 'sm:tw-max-w-[564px]', size === 'md' && 'sm:tw-max-w-[760px]', size === 'lg' && 'sm:tw-max-w-[980px]', size === 'xl' && 'sm:tw-max-w-[115rem]', className),
      onPointerDownOutside: function onPointerDownOutside(e) {
        // don't dismiss dialog when clicking inside the toast
        if (e.target instanceof Element && e.target.closest('[data-sonner-toast]')) {
          e.preventDefault();
        }
      }
    }, props), {}, {
      children: [children, !hideClose && (_DialogPrimitive$Clos || (_DialogPrimitive$Clos = /*#__PURE__*/_jsxs(DialogPrimitive.Close, {
        className: "tw-absolute tw-right-1.2 tw-top-1.2 transition-opacity disabled:tw-pointer-events-none",
        children: [/*#__PURE__*/_jsx(CloseSmall, {
          size: 24,
          className: "tw-text-neutral-light-700"
        }), /*#__PURE__*/_jsx("span", {
          className: "tw-sr-only",
          children: "Close"
        })]
      })))]
    }))]
  });
});
DialogContent.displayName = DialogPrimitive.Content.displayName;

/**
 * @deprecated The preferred way to use dialogs is through the GlobalModals component from '@crehana/compass.ui/modals/globals'.
 * If you need more control, you can use the individual dialog components from '@crehana/compass.ui/modals/dialogs/basic-dialog' or '@crehana/compass.ui/modals/dialogs/complex-dialog'.
 * This component will be removed in a future version.
 */
var DialogHeader = function DialogHeader(_ref3) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsx("div", _objectSpread({
    className: cn('tw-px-2.4 tw-pt-2.4 tw-space-y-1.6 tw-text-center', className)
  }, props));
};
DialogHeader.displayName = 'DialogHeader';

/**
 * @deprecated The preferred way to use dialogs is through the GlobalModals component from '@crehana/compass.ui/modals/globals'.
 * If you need more control, you can use the individual dialog components from '@crehana/compass.ui/modals/dialogs/basic-dialog' or '@crehana/compass.ui/modals/dialogs/complex-dialog'.
 * This component will be removed in a future version.
 */
var DialogFooter = function DialogFooter(_ref4) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsx("div", _objectSpread({
    className: cn('tw-py-2 tw-px-2.4 tw-text-center tw-rounded-b tw-space-x-0.8 tw-border-t tw-border-solid', 'tw-bg-neutral-light-300 tw-border-neutral-light-400 dark:tw-bg-neutral-dark-700 dark:tw-border-neutral-dark-600', className)
  }, props));
};
DialogFooter.displayName = 'DialogFooter';

/**
 * @deprecated The preferred way to use dialogs is through the GlobalModals component from '@crehana/compass.ui/modals/globals'.
 * If you need more control, you can use the individual dialog components from '@crehana/compass.ui/modals/dialogs/basic-dialog' or '@crehana/compass.ui/modals/dialogs/complex-dialog'.
 * This component will be removed in a future version.
 */
var DialogTitle = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsx(DialogPrimitive.Title, _objectSpread({
    ref: ref,
    className: cn('tw-font-h5 tw-line-clamp-2 tw-font-semibold', className)
  }, props));
});
DialogTitle.displayName = DialogPrimitive.Title.displayName;

/**
 * @deprecated The preferred way to use dialogs is through the GlobalModals component from '@crehana/compass.ui/modals/globals'.
 * If you need more control, you can use the individual dialog components from '@crehana/compass.ui/modals/dialogs/basic-dialog' or '@crehana/compass.ui/modals/dialogs/complex-dialog'.
 * This component will be removed in a future version.
 */
var DialogDescription = /*#__PURE__*/React.forwardRef(function (_ref6, ref) {
  var className = _ref6.className,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsx(DialogPrimitive.Description, _objectSpread({
    ref: ref,
    className: cn('tw-font-body4 tw-px-2 tw-pt-1.2 tw-pb-2.4 tw-line-clamp-3 tw-text-center', className)
  }, props));
});
DialogDescription.displayName = DialogPrimitive.Description.displayName;
export { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger };